const filterByBlockName = (blocks, name) => blocks.filter(({ block_name }) => block_name === name);

export default filterByBlockName;
